import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../navbar';
import Index from "../index"

function Productdetails() {
    const { id } = useParams();
    const [product, setProduct] = useState("");
    const [prospectName, setProspectName] = useState('');
    const [prospectEmail, setProspectEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(
                    // `http://localhost:3005/dashboard/products/${id}`
                    `https://portal-sanieldanproperties-api.onrender.com/dashboard/products/${id}`,
                    );
                setProduct(response.data);
            } catch (error) {
                console.error('Error fetching product details:', error);
            }
        };

        fetchProduct();
    }, [id]);

    const handleSubmit = async () => {
        try {
            const response = await axios.post(
                // 'http://localhost:3005/admin/api/sendDetails',
                'https://portal-sanieldanproperties-api.onrender.com/admin/api/sendDetails',
                {
                prospectName,
                prospectEmail,
                mobileNumber,
                productId: id
            });
            console.log(response.data);
            // You can add logic to handle the response, like showing a success message
        } catch (error) {
            console.error('Error sending details:', error);
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'prospectName') {
            setProspectName(value);
        } else if (name === 'prospectEmail') {
            setProspectEmail(value);
        } else if (name === 'mobileNumber') {
            setMobileNumber(value);
        }
    };


    return (
        <div>
            <h1>Product Details</h1>
            <div>
                <label>Title:</label>
                <input type="text" value={product.producttitle} disabled />
            </div>
            <div>
                <label>Price:</label>
                <input type="text" value={`₦ ${Number(product.productprice).toLocaleString()}`} disabled />
            </div>
            <div>
                <label>Location:</label>
                <input type="text" value={product.productlocation} disabled />
            </div>
            <div>
                <label>Prospect's Name:</label>
                <input type="text" name="prospectName" value={prospectName} onChange={handleInputChange} />
            </div>
            <div>
                <label>Prospect's Email:</label>
                <input type="email" name="prospectEmail" value={prospectEmail} onChange={handleInputChange} />
            </div>
            <div>
                <label>Mobile Number:</label>
                <input type="tel" name="mobileNumber" value={mobileNumber} onChange={handleInputChange} />
            </div>
            <button onClick={handleSubmit}>Send</button>
        </div>
    );
}

export default Productdetails;
